// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"5648173f","4066":"83f102bd","7509":"8358a105","9533":"fbca1396"}[chunkId] + ".chunk.css";
};